import Vue from 'vue';
import campaignTransformer from './../../transformers/campaign';

const success = (data, resolve) => {
  Vue.router.push({
    name: 'campaigns.edit',
    params: { id: data.id },
  });
  resolve();
};

const failed = (errors, reject) => {
  reject(campaignTransformer.fetch(errors));
};

export default campaign => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('news_campaigns', campaign)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/campaign/store.js